import React from 'react'

export default React.createContext({
  show: [],
  onClick: () => {},
  registerSection: () => {}
})
